import { Suspense } from "react";
import { Outlet } from "react-router";

import { FullScreenLoader } from "@profitlens/ui/spinner";
import { useIsDesktop } from "@/lib/use-media-query";

import { MobileTabBar } from "./mobile-tab-bar";
import { Sidebar } from "./sidebar";
import { MobileHeader, TopBar } from "./top-bar";

/**
 * Responsive shell: sidebar + top bar on desktop, header + bottom tab bar on mobile.
 * Only one of each is mounted at a time, so no duplicate route subscriptions.
 */
export function AppShell() {
  const isDesktop = useIsDesktop();

  return (
    <div className="flex min-h-dvh bg-background">
      {isDesktop ? <Sidebar /> : null}

      <div className="flex min-w-0 flex-1 flex-col">
        {isDesktop ? <TopBar /> : <MobileHeader />}
        <main className="mx-auto w-full max-w-7xl flex-1 px-4 pb-24 pt-4 lg:px-6 lg:pb-8 lg:pt-6">
          {/* Suspense stays inside the shell so only the page area swaps on navigation. */}
          <Suspense fallback={<FullScreenLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      {isDesktop ? null : <MobileTabBar />}
    </div>
  );
}
